import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";

import { apiRequest, setCsrfToken } from "@mhj/shared/api";
import { useAuth } from "@mhj/shared/auth";
import { Card, Field, buttonClass, inputClass } from "../lib/ui";

export default function Login() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const [busy, setBusy] = useState(false);
  const [form, setForm] = useState({ identifier: "", password: "" });

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setBusy(true);
    try {
      const response = await apiRequest<{ csrfToken?: string }>("/auth/login", {
        method: "POST",
        data: { identifier: form.identifier.trim(), password: form.password },
      });
      if (response.csrfToken) setCsrfToken(response.csrfToken);
      await refresh();
      navigate("/dashboard");
    } catch (error) {
      toast.error((error as Error).message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="space-y-5">
      <Card title="Sign in" description="Use the phone number or email address you registered with.">
        <form className="space-y-4" onSubmit={submit}>
          <Field label="Phone number or email" required>
            <input
              className={inputClass}
              value={form.identifier}
              onChange={(e) => setForm({ ...form, identifier: e.target.value })}
              autoComplete="username"
              placeholder="08031234567"
            />
          </Field>
          <Field label="Password" required>
            <input
              className={inputClass}
              type="password"
              value={form.password}
              onChange={(e) => setForm({ ...form, password: e.target.value })}
              autoComplete="current-password"
            />
          </Field>
          <button type="submit" className={buttonClass} disabled={busy}>
            {busy ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </Card>

      <p className="text-center text-sm text-slate-600">
        No account yet?{" "}
        <Link to="/register" className="font-medium text-blue-700 underline">
          Create one
        </Link>
      </p>
    </div>
  );
}
